var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavoriteFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/favorite-fill",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.0068839,4.61441679 L12.9679163,3.68656053 C14.3221865,2.37900752 16.2443622,1.7798593 18.1342738,2.07619063 C20.0241853,2.37252195 21.6515549,3.52822608 22.5082213,5.1823744 C24.589587,9.20000953 19.8037958,15.7777706 13.0604061,21.5022076 L12.4604457,22.0050036 C12.1986407,22.2216228 11.8121355,22.2204195 11.551781,22.0021748 L10.940208,21.4834989 C4.07279534,15.5901177 -0.582796411,9.21265057 1.50170756,5.18262125 C2.35839597,3.52726817 3.98658042,2.37072928 5.87753498,2.07436494 C7.76848954,1.77800061 9.69162509,2.37795045 11.0458451,3.68655436 L12.0068839,4.61441679 Z",
  id: "\\uD83C\\uDFA8-icon-color",
  fill: "#32373C"
}))));
export { SvgFavoriteFill as ReactComponent };
export default __webpack_public_path__ + "images/favorite-fill.svg";